export const QUOTE_PLUGIN_KEY = 'uui-richTextEditor-quote';
export const QUOTE_TYPE = 'uui-richTextEditor-quote';
